import React from 'react'

import Tab, { TabProps } from '@material-ui/core/Tab'
import { Link, LinkProps } from 'react-router-dom'

interface Props {
}

type InjectedProps = Props & TabProps & LinkProps

// TODO
// tslint:disable-next-line:no-any
const NavTab: React.SFC<InjectedProps> = (props) => <Tab component={Link as any} {...props} />

export default NavTab
